import registerDocument from '../../../common/documents/index';
import presentationalComponent from './Document';
import containerComponent from './DocumentContainer';
import modalComponent from './modal/DocumentModal';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { isIconViewLike } from '../../../common/elements/utils/elementDisplayUtils';

export default () =>
    registerDocument({
        containerComponent,
        presentationalComponent,
        modalComponent,
        tools: [
            TOOLS.RICH_TEXT,
            TOOLS.COLOR,
            TOOLS.DISPLAY_MODE,
            { ...TOOLS.CAPTION, predicate: (element) => !isIconViewLike(element) },
            { ...TOOLS.REACTION, predicate: (element) => !isIconViewLike(element) },
        ],
    });
